import { Component, OnInit } from '@angular/core';
import { Chart, registerables } from 'chart.js';
import { GoogleAnalyticsService } from 'ngx-google-analytics';
import { PriceProviderService } from 'src/app/services/price-provider.service';
import calculateBaseOdds from 'src/app/utils/pity-odds-calculator';

Chart.register(...registerables);

@Component({
  selector: 'ulti-jewels-root',
  templateUrl: './ulti-jewels.component.html',
  styleUrls: ['../../shared-scss/default.scss'],
  standalone: false,
})
export class UltiJewelsComponent implements OnInit {
  constructor(
    private readonly gaService: GoogleAnalyticsService,
    readonly priceProvider: PriceProviderService
  ) {}

  ngOnInit(): void {
    this.SimulateUpgrading(false);
  }
  title = 'flyff-upgrade-calculator';

  simulationCount = 10000;

  xProsUsed: number[] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
  sunstonesUsed: number[] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

  customUpgradeBonus = 0;
  getModifier() {
    let bonus = this.customUpgradeBonus;
    if (this.priceProvider.isFwc) {
      bonus += 50;
    }
    return 1 + bonus / 100;
  }
  isUpgradeEvent = false;
  currentAttemptsIn = 0;
  currentUpgrade = 0;
  targetUpgrade = 10;

  baseOdds = [7, 6, 4.5, 3.4, 2.5, 1.8, 1.4, 0.95, 0.7, 0.5];
  baseUpgradeEventOdds = [100, 100, 100, 100, 100, 100, 100, 100, 100, 100];

  pityOdds = this.baseOdds.map((x) => calculateBaseOdds(x));
  pityOddsEvent = this.baseUpgradeEventOdds.map((x) => calculateBaseOdds(x));

  myChart: Chart | undefined = undefined;

  GenerateChart() {
    if (this.myChart) {
      this.myChart.destroy();
    }

    const chartData: any = {
      labels: ['+0 > +1', '+1 > +2', '+2 > +3', '+3 > +4', '+4 > +5', '+5 > +6', '+6 > +7', '+7 > +8', '+8 > +9', '+9 > +10'],
      datasets: [
        {
          label: 'Attempts',
          data: this.xProsUsed.map((x) => x / this.simulationCount),
          borderWidth: 1,
        },
      ],
    };

    const config: any = {
      type: 'bar',
      data: chartData,
      options: {
        scales: {
          y: {
            beginAtZero: true,
          },
        },
      },
    };

    const chartElem = <HTMLCanvasElement>(
      document.getElementById(`upgrade-data-chart`)
    );

    this.myChart = new Chart(chartElem, config);
  }

  SimulateUpgrading(isUserInput = true) {
    if (!this.verifyInput()) {
      return;
    }

    if (isUserInput) {
      this.gaService.event(
        'simulate_beta_ulti_jewelry_upgrade',
        'simulate',
        'Simulate beta ultimate jewelry upgrade',
        this.simulationCount,
        true
      );
    }

    // Reset starter values
    this.xProsUsed = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.sunstonesUsed = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

    // Calculate modified odds with upgrade bonus
    this.pityOdds = this.baseOdds.map((x) => calculateBaseOdds(x * this.getModifier()));
    this.pityOddsEvent = this.baseUpgradeEventOdds.map((x) => calculateBaseOdds(x * this.getModifier()));

    // Start upgrading
    for (let i = 0; i < this.simulationCount; i++) {
      let currentUpgrade = this.currentUpgrade;

      while (currentUpgrade < this.targetUpgrade) {
        let failedTries = 0;
        if (currentUpgrade === this.currentUpgrade) {
          failedTries = this.currentAttemptsIn;
        }
        let isSuccessful = false;
        while (!isSuccessful) {
          isSuccessful = this.SimulateSingleUpgrade(
            currentUpgrade,
            failedTries
          );
          if (!isSuccessful) {
            failedTries++;
          }
        }
        currentUpgrade++;
      }
    }

    this.GenerateChart();
  }

  verifyInput() {
    // clear all red inputs
    let isValid = true;
    if (this.currentUpgrade < 0 || this.currentUpgrade > 9) {
      // make input red
      isValid = false;
    }
    if (this.targetUpgrade < 1 || this.targetUpgrade > 10) {
      // make input red
      isValid = false;
    }
    if (this.currentAttemptsIn < 0) {
      // make input red
      isValid = false;
    }
    if (this.currentUpgrade >= this.targetUpgrade) {
      // make input red
      isValid = false;
    }
    if (this.priceProvider.xProPrice < 0) {
      // make input red
      isValid = false;
    }
    if (this.priceProvider.sunstonePrice < 0) {
      // make input red
      isValid = false;
    }
    return isValid;
  }

  addUpgradeTry(currentUpgrade: number) {
    this.xProsUsed[currentUpgrade]++;
    this.sunstonesUsed[currentUpgrade]++;
  }

  SimulateSingleUpgrade(currentUpgrade: number, failedTries: number): boolean {
    this.addUpgradeTry(currentUpgrade);
    const random = Math.random() * 100;
    let odds = this.GetUpgradeOdds()[currentUpgrade] * (failedTries + 1);

    if (random < odds) {
      return true;
    }
    return false;
  }

  GetXprosUsed(): number {
    return this.xProsUsed.reduce((a, b) => a + b, 0);
  }

  GetSunstonesUsed(): number {
    return this.sunstonesUsed.reduce((a, b) => a + b, 0);
  }

  GetTotalPenyaCost(): number {
    const totalXproCost = this.GetSunstonesUsed() * this.priceProvider.xProPrice;
    const totalSunstoneCost = this.GetSunstonesUsed() * this.priceProvider.sunstonePrice;
    return totalXproCost + totalSunstoneCost;
  }

  GetUpgradeOdds(): number[] {
    if (this.isUpgradeEvent) {
      return this.pityOddsEvent;
    }
    return this.pityOdds;
  }
}
